export const API =
  window.location.hostname === "localhost"
    ? "http://localhost:8080"
    : `https://api.${window.location.hostname}`;

export const apiFetch = (path, options = {}) =>
  fetch(`${API}${path}`, { ...options, credentials: "include" });
